module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-101.f2b8dc48.jpg";